export default function Security (props) {
    return (
        <svg stroke={props.stroke} className={props.className} style={props.style} xmlns="http://www.w3.org/2000/svg" viewBox="-4 -6 49 56">
            <path d="M 2 10 C 11 8 16 4 20 0 C 24 4 29 8 39 10 C 39 23 33 34 20 44 C 7 34 2 23 2 10 C 11 8 16 4 20 0" strokeWidth="7" />
        </svg>
    )
}